/**
 * B100110 商品マスタメンテ
 */
import {
  SText,
  SCodeSelect,
  SDateField,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STextField,
  SFileButton,
  msgState,
  SConfirmDialog,
} from "components";
import {
  getSCode,
  KazeiKbn,
  MinuszaikocheckKbn,
  B100110Mode,
  SakujoyoteiKbn,
  SCode,
  SetshohinKbn,
  ShohinshubetsuKbn,
  ShokuchiKbn,
  TankaKbn,
  UrikiriKbn,
  ZaikohikiateKbn,
  ZaikokanriKbn,
} from "messages/codes";
import { labels } from "messages/labels";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { focusState, navigateTypeState, useFocus } from "states";
import {
  B000111,
  B000170,
  B000200,
  B000201,
  B000202,
  GamenInputId,
} from "pages";
import { date } from "services";
import {
  meishoKbn,
  setshohinKbn,
  shohinshubetsuKbn,
  tankaKbn,
  zaikohikiateKbn,
  zaikokanriKbn,
} from "services/codes";
import {
  B000111SakaNm,
  B000111WhtankaNm,
  B000111WhgentankaNm,
  B000111ChohyoBunruiNm1,
  B000111ChohyoBunruiNm2,
  B000111ChohyoBunruiNm3,
  B000111ChohyoBunruiNm4,
  B000111ChohyoBunruiNm5,
  B000111ChohyoBunruiNm6,
  B000111ChohyoBunruiNm7,
  B000111ChohyoBunruiNm8,
  B000111ChohyoBunruiNm9,
  B000111ChohyoBunruiNm10,
  B000111ChohyoBunruiNm11,
  B000111ChohyoBunruiNm12,
  B000111ChohyoBunruiNm13,
  B000111ChohyoBunruiNm14,
  B000111ChohyoBunruiNm15,
  B000111KakoshubetsuNm,
  B000111ShobumNm1,
  B000111ShobumNm2,
  B000111ShobumNm3,
  B000111ShobumNm4,
  B000111ShobumNm5,
  B000200ZairyoshohinNm,
  B000202ShodaibunruiNm,
  B000202ShochubunruiNm,
  B000202ShoshobunruiNm,
  B100110HandleSetNm,
  B100110Shohin,
  B100110Create,
  B100110Update,
  catchRestError,
  B000170ShireNmr,
  B100110SanshoShohin,
} from "clients/rest";
import { useNavigate } from "react-router-dom";
import { getClientMessage } from "messages";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  modeKbn: SCode;
  shohinCd: string;
  sanshoShohinCd: string;
  shohinNm: string;
  shohinKana: string;
  shohinNmr: string;
  shokuchiKbn: SCode;
  janCd: string;
  sakaCd: string;
  sakaNm: string;
  vol: string;
  shireCd: string;
  shireNmr: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  itfCd: string;
  kazeiKbn: SCode;
  tankaKbn: SCode;
  whtankaCd: string;
  whtankaNm: string;
  whgentankaCd: string;
  whgentankaNm: string;
  setshohinKbn: SCode;
  shohinshubetsuKbn: SCode;
  urikiriKbn: SCode;
  zairyoshohinCd: string;
  zairyoshohinNm: string;
  tashisun: string;
  loss2: string;
  sunpo: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  kakoshubetsuCd: string;
  kakoshubetsuNm: string;
  shiyo1: string;
  shiyo2: string;
  shiyo3: string;
  zaikokanriKbn: SCode;
  zaikohikiateKbn: SCode;
  minuszaikocheckKbn: SCode;
  sakujoyoteiKbn: SCode;
  shobunCd1: string;
  shobunNm1: string;
  shobunCd2: string;
  shobunNm2: string;
  shobunCd3: string;
  shobunNm3: string;
  shobunCd4: string;
  shobunNm4: string;
  shobunCd5: string;
  shobunNm5: string;
  shodaibun: string;
  shodaibunNm: string;
  shochubun: string;
  shochubunNm: string;
  shoshobun: string;
  shoshobunNm: string;
  chohyoBunruiCd1: string;
  chohyoBunruiNm1: string;
  chohyoBunruiCd2: string;
  chohyoBunruiNm2: string;
  chohyoBunruiCd3: string;
  chohyoBunruiNm3: string;
  chohyoBunruiCd4: string;
  chohyoBunruiNm4: string;
  chohyoBunruiCd5: string;
  chohyoBunruiNm5: string;
  chohyoBunruiCd6: string;
  chohyoBunruiNm6: string;
  chohyoBunruiCd7: string;
  chohyoBunruiNm7: string;
  chohyoBunruiCd8: string;
  chohyoBunruiNm8: string;
  chohyoBunruiCd9: string;
  chohyoBunruiNm9: string;
  chohyoBunruiCd10: string;
  chohyoBunruiNm10: string;
  chohyoBunruiCd11: string;
  chohyoBunruiNm11: string;
  chohyoBunruiCd12: string;
  chohyoBunruiNm12: string;
  chohyoBunruiCd13: string;
  chohyoBunruiNm13: string;
  chohyoBunruiCd14: string;
  chohyoBunruiNm14: string;
  chohyoBunruiCd15: string;
  chohyoBunruiNm15: string;
  version: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  modeKbn: getSCode(B100110Mode, "0"),
  shohinCd: "",
  sanshoShohinCd: "",
  shohinNm: "",
  shohinKana: "",
  shohinNmr: "",
  shokuchiKbn: getSCode(ShokuchiKbn, "0"),
  janCd: "",
  sakaCd: "",
  sakaNm: "",
  vol: "",
  shireCd: "",
  shireNmr: "",
  torihikikaishiYmd: date(),
  torihikishuryoYmd: "99991231",
  itfCd: "",
  kazeiKbn: getSCode(KazeiKbn, "0"),
  tankaKbn: getSCode(TankaKbn, "0"),
  whtankaCd: "",
  whtankaNm: "",
  whgentankaCd: "",
  whgentankaNm: "",
  setshohinKbn: getSCode(SetshohinKbn, "0"),
  shohinshubetsuKbn: getSCode(ShohinshubetsuKbn, "1"),
  urikiriKbn: getSCode(UrikiriKbn, "0"),
  zairyoshohinCd: "",
  zairyoshohinNm: "",
  tashisun: "",
  loss2: "",
  sunpo: "",
  sotosunW: "",
  sotosunH: "",
  uchisunW: "",
  uchisunH: "",
  kakoshubetsuCd: "",
  kakoshubetsuNm: "",
  shiyo1: "",
  shiyo2: "",
  shiyo3: "",
  zaikokanriKbn: getSCode(ZaikokanriKbn, "1"),
  zaikohikiateKbn: getSCode(ZaikohikiateKbn, "1"),
  minuszaikocheckKbn: getSCode(MinuszaikocheckKbn, "1"),
  sakujoyoteiKbn: getSCode(SakujoyoteiKbn, "0"),
  shobunCd1: "",
  shobunNm1: "",
  shobunCd2: "",
  shobunNm2: "",
  shobunCd3: "",
  shobunNm3: "",
  shobunCd4: "",
  shobunNm4: "",
  shobunCd5: "",
  shobunNm5: "",
  shodaibun: "",
  shodaibunNm: "",
  shochubun: "",
  shochubunNm: "",
  shoshobun: "",
  shoshobunNm: "",
  chohyoBunruiCd1: "",
  chohyoBunruiNm1: "",
  chohyoBunruiCd2: "",
  chohyoBunruiNm2: "",
  chohyoBunruiCd3: "",
  chohyoBunruiNm3: "",
  chohyoBunruiCd4: "",
  chohyoBunruiNm4: "",
  chohyoBunruiCd5: "",
  chohyoBunruiNm5: "",
  chohyoBunruiCd6: "",
  chohyoBunruiNm6: "",
  chohyoBunruiCd7: "",
  chohyoBunruiNm7: "",
  chohyoBunruiCd8: "",
  chohyoBunruiNm8: "",
  chohyoBunruiCd9: "",
  chohyoBunruiNm9: "",
  chohyoBunruiCd10: "",
  chohyoBunruiNm10: "",
  chohyoBunruiCd11: "",
  chohyoBunruiNm11: "",
  chohyoBunruiCd12: "",
  chohyoBunruiNm12: "",
  chohyoBunruiCd13: "",
  chohyoBunruiNm13: "",
  chohyoBunruiCd14: "",
  chohyoBunruiNm14: "",
  chohyoBunruiCd15: "",
  chohyoBunruiNm15: "",
  version: "",
};

// 固定値
// モード(新規)
const modeNew = "0";
// モード(新規)
const modeEdit = "1";

const focusId = "B100110";

export const B100110 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};
const Page = (props: Props) => {
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();
  // 画面遷移の処理
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 活性設定
  // 新規モードかどうか
  const isNew = methods.watch("modeKbn")?.value === modeNew;
  // 単価区分が「1:WH単価」かどうか
  const isTankaKbnWhtanka =
    Number(methods.watch("tankaKbn")?.value) === tankaKbn.wh;
  // セット商品かどうか
  const isSetshohin =
    Number(methods.watch("setshohinKbn")?.value) === setshohinKbn.set;
  // 商品種別が見込生産品or受注生産品かどうか
  const isMikomiOrJuchuSeisanhin =
    Number(methods.watch("shohinshubetsuKbn")?.value) ===
      shohinshubetsuKbn.makeToStockProduct ||
    Number(methods.watch("shohinshubetsuKbn")?.value) ===
      shohinshubetsuKbn.madeToOrder;
  // 9:材料品かどうか
  const isZairyohin =
    Number(methods.watch("shohinshubetsuKbn")?.value) ===
    shohinshubetsuKbn.materials;
  // 在庫管理区分が「0:しない」かどうか
  const isKanriShinai =
    methods.watch("zaikokanriKbn")?.value.toString() === zaikokanriKbn.off;
  // 在庫引当区分が「0:しない」かどうか
  const isHikiateShinai =
    methods.watch("zaikohikiateKbn")?.value.toString() === zaikohikiateKbn.off;

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  // モード変更時
  const handleChangeModeKbn = () => {
    if (isNew) {
      methods.reset();
      methods.reset({
        ...methods.getValues(),
        shohinCd: "",
        sanshoShohinCd: "",
      });
      methods.setValue("modeKbn", getSCode(B100110Mode, modeEdit));
    } else {
      methods.reset();
      methods.reset({
        ...methods.getValues(),
        shohinCd: "",
        sanshoShohinCd: "",
      });
    }
  };

  // 更新
  const handleClickUpdateButton = () => {
    // 新規の場合
    if (isNew) {
      B100110Create(methods)
        .then((response) => {
          methods.reset();
          methods.reset({
            ...methods.getValues(),
            shohinCd: "",
            sanshoShohinCd: "",
          });
          // ↓これがあると完了メッセージが表示される
          methods.setValue("shohinCd", "");
          setMsg(getClientMessage("B100110_001", response.data.shohinCd));
        })
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
        });
    }
    // 更新の場合
    else {
      B100110Update(methods)
        .then((response) => {
          methods.reset();
          methods.reset({
            ...methods.getValues(),
            shohinCd: "",
            sanshoShohinCd: "",
          });
          // ↓これがあると完了メッセージが表示される
          methods.setValue("shohinCd", "");
          setMsg(getClientMessage("B100110_002", response.data.shohinCd));
        })
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
        });
    }
  };

  // 単価区分変更
  const changeTankaKbn = () => {
    const fields = methods.getValues();

    // 単価区分が「0:通常」の場合
    if (Number(fields.tankaKbn?.value) === tankaKbn.tujo) {
      // WH単価、WH原単価をクリア
      methods.setValue("whtankaCd", "");
      methods.setValue("whtankaNm", "");
      methods.setValue("whgentankaCd", "");
      methods.setValue("whgentankaNm", "");
    }
  };

  // セット商品変更
  const changeSetshohin = () => {
    // 商品種別を「1:通常商品」に設定
    methods.setValue(
      "shohinshubetsuKbn",
      getSCode(ShohinshubetsuKbn, shohinshubetsuKbn.regularProduct)
    );

    // 商品種別区分変更処理を呼び出す
    changeShohinshubetsu();
  };

  // 商品種別変更
  const changeShohinshubetsu = () => {
    const fields = methods.getValues();

    // 入力不可能になるフィールドに入力されている値を空文字に置き換える
    // 商品種別が「3:見込生産品」or「4:受注生産品」以外の場合
    if (
      Number(fields.shohinshubetsuKbn?.value) !==
        shohinshubetsuKbn.makeToStockProduct &&
      Number(fields.shohinshubetsuKbn?.value) !== shohinshubetsuKbn.madeToOrder
    ) {
      methods.setValue("zairyoshohinCd", "");
      methods.setValue("zairyoshohinNm", "");
      methods.setValue("kakoshubetsuCd", "");
      methods.setValue("kakoshubetsuNm", "");
      methods.setValue("shiyo1", "");
      methods.setValue("shiyo2", "");
      methods.setValue("shiyo3", "");
    }

    // 商品種別が「9:材料品」の場合
    if (
      Number(fields.shohinshubetsuKbn?.value) === shohinshubetsuKbn.materials
    ) {
      methods.setValue("sotosunW", "");
      methods.setValue("sotosunH", "");
      methods.setValue("uchisunW", "");
      methods.setValue("uchisunH", "");
    }
    // 商品種別が「9:材料品」以外の場合
    else {
      methods.setValue("tashisun", "");
      methods.setValue("loss2", "");
      methods.setValue("sunpo", "");
    }
  };

  // 在庫管理が「0:管理しない」に変更された場合に在庫引当を「0:引当しない」に変更するメソッド
  const chengeZaikokanri = () => {
    const fields = methods.getValues();

    if (fields.zaikokanriKbn?.value.toString() === zaikokanriKbn.off) {
      methods.setValue(
        "zaikohikiateKbn",
        getSCode(ZaikohikiateKbn, zaikohikiateKbn.off)
      );
    }
  };

  // 在庫引当が「1:引当する」に変更された場合にマイナス在庫を「1:チェックする」に変更するメソッド
  const chengeZaikohikiate = () => {
    const fields = methods.getValues();

    if (fields.zaikohikiateKbn?.value.toString() === zaikohikiateKbn.on) {
      methods.setValue("minuszaikocheckKbn", getSCode(MinuszaikocheckKbn, "1"));
    }
  };

  // excelボタンクリック時
  const handleMoveOutput = () => {
    // 商品マスタ出力画面へ遷移する。
    setMenuNavigate("next");
    navigate("/b100113");
  };

  // excel取込ボタンクリック時
  const handleMoveImport = () => {
    const gamenInputId: GamenInputId = {
      gamenId: "100110",
    };

    // マスタ取込画面へ遷移する。
    setMenuNavigate("next");
    navigate("/b100900", { state: gamenInputId });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="商品マスタメンテ"
        gridTemplateColumns="8rem 6rem 6rem 8rem 8rem 6rem 6rem 11rem 1fr"
      >
        <SFileButton
          label={labels.buttons.excel}
          gridColumn="8"
          align="right"
          {...register(62)}
          onClick={handleMoveOutput}
        />
        <SNormalButton
          label={labels.buttons.excelImport}
          gridColumn="9"
          align="right"
          {...register(63)}
          onClick={handleMoveImport}
        />

        <SLabel required gridColumn={1}>
          モード
        </SLabel>
        <SCodeSelect
          name="modeKbn"
          label="モード"
          options={B100110Mode}
          onChange={() => handleChangeModeKbn()}
          required
          {...register(1)}
        />
        <SLabel required={!isNew} gridColumn={1}>
          商品コード
        </SLabel>
        <SNumberField
          name="shohinCd"
          label="商品コード"
          code
          required
          size={10}
          gridColumn="span 2"
          disabled={isNew}
          dialog={<B000200 deljogaiKbn="1" />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCd", data.shohinCd ?? "");
            methods.setValue("shohinNm", data.shohinNm ?? "");
            methods.setValue("shohinKana", data.shohinKana ?? "");
            methods.setValue("shohinNmr", data.shohinNmr ?? "");
            methods.setValue(
              "shokuchiKbn",
              getSCode(ShokuchiKbn, data.shokuchiKbn) ?? null
            );
            methods.setValue("janCd", data.janCd ?? "");
            methods.setValue("sakaCd", data.sakaCd ?? "");
            methods.setValue("vol", data.vol ?? "");
            methods.setValue("shireCd", data.shireCd ?? "");
            methods.setValue(
              "torihikikaishiYmd",
              data.torihikikaishiYmd ?? null
            );
            methods.setValue(
              "torihikishuryoYmd",
              data.torihikishuryoYmd ?? null
            );
            methods.setValue("itfCd", data.itfCd ?? "");
            methods.setValue(
              "kazeiKbn",
              getSCode(KazeiKbn, data.kazeiKbn) ?? null
            );
            methods.setValue(
              "tankaKbn",
              getSCode(TankaKbn, data.tankaKbn) ?? null
            );
            methods.setValue("whtankaCd", data.whtankaCd ?? "");
            methods.setValue("whgentankaCd", data.whgentankaCd ?? "");
            methods.setValue(
              "setshohinKbn",
              getSCode(SetshohinKbn, data.setshohinKbn) ?? null
            );
            methods.setValue(
              "shohinshubetsuKbn",
              getSCode(ShohinshubetsuKbn, data.shohinshubetsuKbn) ?? null
            );
            methods.setValue(
              "urikiriKbn",
              getSCode(UrikiriKbn, data.urikiriKbn) ?? null
            );
            methods.setValue("zairyoshohinCd", data.zairyoshohinCd ?? "");
            methods.setValue("tashisun", data.tashisun ?? "");
            methods.setValue("loss2", data.loss2 ?? "");
            methods.setValue("sunpo", data.sunpo ?? "");
            methods.setValue("sotosunW", data.sotosunW ?? "");
            methods.setValue("sotosunH", data.sotosunH ?? "");
            methods.setValue("uchisunW", data.uchisunW ?? "");
            methods.setValue("uchisunH", data.uchisunH ?? "");
            methods.setValue("kakoshubetsuCd", data.kakoshubetsuCd ?? "");
            methods.setValue("shiyo1", data.shiyo1 ?? "");
            methods.setValue("shiyo2", data.shiyo2 ?? "");
            methods.setValue("shiyo3", data.shiyo3 ?? "");
            methods.setValue(
              "zaikokanriKbn",
              getSCode(ZaikokanriKbn, data.zaikokanriKbn) ?? null
            );
            methods.setValue(
              "zaikohikiateKbn",
              getSCode(ZaikohikiateKbn, data.zaikohikiateKbn) ?? null
            );
            methods.setValue(
              "minuszaikocheckKbn",
              getSCode(MinuszaikocheckKbn, data.minuszaikocheckKbn) ?? null
            );
            methods.setValue(
              "sakujoyoteiKbn",
              getSCode(SakujoyoteiKbn, data.sakujoyoteiKbn) ?? null
            );

            methods.setValue("shobunCd1", data.shobunCd1 ?? "");
            methods.setValue("shobunCd2", data.shobunCd2 ?? "");
            methods.setValue("shobunCd3", data.shobunCd3 ?? "");
            methods.setValue("shobunCd4", data.shobunCd4 ?? "");
            methods.setValue("shobunCd5", data.shobunCd5 ?? "");
            methods.setValue("shodaibun", data.shodaibun ?? "");
            methods.setValue("shochubun", data.shochubun ?? "");
            methods.setValue("shoshobun", data.shoshobun ?? "");
            methods.setValue("chohyoBunruiCd1", data.chohyoBunruiCd1 ?? "");
            methods.setValue("chohyoBunruiCd2", data.chohyoBunruiCd2 ?? "");
            methods.setValue("chohyoBunruiCd3", data.chohyoBunruiCd3 ?? "");
            methods.setValue("chohyoBunruiCd4", data.chohyoBunruiCd4 ?? "");
            methods.setValue("chohyoBunruiCd5", data.chohyoBunruiCd5 ?? "");
            methods.setValue("chohyoBunruiCd6", data.chohyoBunruiCd6 ?? "");
            methods.setValue("chohyoBunruiCd7", data.chohyoBunruiCd7 ?? "");
            methods.setValue("chohyoBunruiCd8", data.chohyoBunruiCd8 ?? "");
            methods.setValue("chohyoBunruiCd9", data.chohyoBunruiCd9 ?? "");
            methods.setValue("chohyoBunruiCd10", data.chohyoBunruiCd10 ?? "");
            methods.setValue("chohyoBunruiCd11", data.chohyoBunruiCd11 ?? "");
            methods.setValue("chohyoBunruiCd12", data.chohyoBunruiCd12 ?? "");
            methods.setValue("chohyoBunruiCd13", data.chohyoBunruiCd13 ?? "");
            methods.setValue("chohyoBunruiCd14", data.chohyoBunruiCd14 ?? "");
            methods.setValue("chohyoBunruiCd15", data.chohyoBunruiCd15 ?? "");
            methods.setValue("version", data.version ?? "");

            // コードに紐づく名称の設定
            B100110HandleSetNm(methods, navigate, setMsg);
          }}
          onBlur={() => B100110Shohin(methods, navigate, setMsg)}
          {...register(2)}
        />
        <SLabel gridColumn={5}>参照コード</SLabel>
        <SNumberField
          name="sanshoShohinCd"
          code
          size={10}
          gridColumn="span 2"
          disabled={!isNew}
          dialog={<B000200 deljogaiKbn="1" />}
          handleSubmit={(data: any) => {
            methods.setValue("sanshoShohinCd", data.shohinCd ?? "");
            methods.setValue("shohinNm", data.shohinNm ?? "");
            methods.setValue("shohinKana", data.shohinKana ?? "");
            methods.setValue("shohinNmr", data.shohinNmr ?? "");
            methods.setValue(
              "shokuchiKbn",
              getSCode(ShokuchiKbn, data.shokuchiKbn) ?? null
            );
            methods.setValue("sakaCd", data.sakaCd ?? "");
            methods.setValue("vol", data.vol ?? "");
            methods.setValue("shireCd", data.shireCd ?? "");
            methods.setValue(
              "torihikikaishiYmd",
              data.torihikikaishiYmd ?? null
            );
            methods.setValue(
              "torihikishuryoYmd",
              data.torihikishuryoYmd ?? null
            );
            methods.setValue("itfCd", data.itfCd ?? "");
            methods.setValue(
              "kazeiKbn",
              getSCode(KazeiKbn, data.kazeiKbn) ?? null
            );
            methods.setValue(
              "tankaKbn",
              getSCode(TankaKbn, data.tankaKbn) ?? null
            );
            methods.setValue("whtankaCd", data.whtankaCd ?? "");
            methods.setValue("whgentankaCd", data.whgentankaCd ?? "");
            methods.setValue(
              "setshohinKbn",
              getSCode(SetshohinKbn, data.setshohinKbn) ?? null
            );
            methods.setValue(
              "shohinshubetsuKbn",
              getSCode(ShohinshubetsuKbn, data.shohinshubetsuKbn) ?? null
            );
            methods.setValue(
              "urikiriKbn",
              getSCode(UrikiriKbn, data.urikiriKbn) ?? null
            );
            methods.setValue("zairyoshohinCd", data.zairyoshohinCd ?? "");
            methods.setValue("tashisun", data.tashisun ?? "");
            methods.setValue("loss2", data.loss2 ?? "");
            methods.setValue("sunpo", data.sunpo ?? "");
            methods.setValue("sotosunW", data.sotosunW ?? "");
            methods.setValue("sotosunH", data.sotosunH ?? "");
            methods.setValue("uchisunW", data.uchisunW ?? "");
            methods.setValue("uchisunH", data.uchisunH ?? "");
            methods.setValue("kakoshubetsuCd", data.kakoshubetsuCd ?? "");
            methods.setValue("shiyo1", data.shiyo1 ?? "");
            methods.setValue("shiyo2", data.shiyo2 ?? "");
            methods.setValue("shiyo3", data.shiyo3 ?? "");
            methods.setValue(
              "zaikokanriKbn",
              getSCode(ZaikokanriKbn, data.zaikokanriKbn) ?? null
            );
            methods.setValue(
              "zaikohikiateKbn",
              getSCode(ZaikohikiateKbn, data.zaikohikiateKbn) ?? null
            );
            methods.setValue(
              "minuszaikocheckKbn",
              getSCode(MinuszaikocheckKbn, data.minuszaikocheckKbn) ?? null
            );
            methods.setValue(
              "sakujoyoteiKbn",
              getSCode(SakujoyoteiKbn, data.sakujoyoteiKbn) ?? null
            );

            methods.setValue("shobunCd1", data.shobunCd1 ?? "");
            methods.setValue("shobunCd2", data.shobunCd2 ?? "");
            methods.setValue("shobunCd3", data.shobunCd3 ?? "");
            methods.setValue("shobunCd4", data.shobunCd4 ?? "");
            methods.setValue("shobunCd5", data.shobunCd5 ?? "");
            methods.setValue("shodaibun", data.shodaibun ?? "");
            methods.setValue("shochubun", data.shochubun ?? "");
            methods.setValue("shoshobun", data.shoshobun ?? "");
            methods.setValue("chohyoBunruiCd1", data.chohyoBunruiCd1 ?? "");
            methods.setValue("chohyoBunruiCd2", data.chohyoBunruiCd2 ?? "");
            methods.setValue("chohyoBunruiCd3", data.chohyoBunruiCd3 ?? "");
            methods.setValue("chohyoBunruiCd4", data.chohyoBunruiCd4 ?? "");
            methods.setValue("chohyoBunruiCd5", data.chohyoBunruiCd5 ?? "");
            methods.setValue("chohyoBunruiCd6", data.chohyoBunruiCd6 ?? "");
            methods.setValue("chohyoBunruiCd7", data.chohyoBunruiCd7 ?? "");
            methods.setValue("chohyoBunruiCd8", data.chohyoBunruiCd8 ?? "");
            methods.setValue("chohyoBunruiCd9", data.chohyoBunruiCd9 ?? "");
            methods.setValue("chohyoBunruiCd10", data.chohyoBunruiCd10 ?? "");
            methods.setValue("chohyoBunruiCd11", data.chohyoBunruiCd11 ?? "");
            methods.setValue("chohyoBunruiCd12", data.chohyoBunruiCd12 ?? "");
            methods.setValue("chohyoBunruiCd13", data.chohyoBunruiCd13 ?? "");
            methods.setValue("chohyoBunruiCd14", data.chohyoBunruiCd14 ?? "");
            methods.setValue("chohyoBunruiCd15", data.chohyoBunruiCd15 ?? "");

            // コードに紐づく名称の設定
            B100110HandleSetNm(methods, navigate, setMsg);
          }}
          onBlur={() => B100110SanshoShohin(methods, navigate, setMsg)}
          {...register(3)}
        />

        <SLabel required gridColumn={1}>
          商品名
        </SLabel>
        <STextField
          name="shohinNm"
          label="商品名"
          required
          size={40}
          gridColumn="span 3"
          {...register(4)}
        />
        <SLabel gridColumn={5}>商品カナ</SLabel>
        <STextField
          name="shohinKana"
          size={40}
          gridColumn="span 3"
          {...register(5)}
        />

        <SLabel required gridColumn={1}>
          商品名略
        </SLabel>
        <STextField
          name="shohinNmr"
          label="商品名略"
          required
          size={24}
          gridColumn="span 3"
          {...register(6)}
        />
        <SLabel required gridColumn={5}>
          諸口
        </SLabel>
        <SCodeSelect
          name="shokuchiKbn"
          label="諸口"
          options={ShokuchiKbn}
          required
          {...register(7)}
        />

        <SLabel gridColumn={1}>JANコード</SLabel>
        <SNumberField
          name="janCd"
          code
          size={13}
          gridColumn="span 2"
          dialog={<B000201 />}
          handleSubmit={(data: any) => {
            methods.setValue("janCd", data.janKouho);
          }}
          {...register(8)}
        />
        <SLabel gridColumn={5}>作家名</SLabel>
        <SNumberField
          name="sakaCd"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.sakaNm} />}
          handleSubmit={(data: any) => {
            methods.setValue("sakaCd", data.meishoCd);
            methods.setValue("sakaNm", data.meishoNm1);
          }}
          onBlur={() => B000111SakaNm(methods, navigate, setMsg)}
          {...register(9)}
        />
        <STextField name="sakaNm" disabled gridColumn="span 2" />

        <SLabel gridColumn={1}>VOL</SLabel>
        <STextField
          name="vol"
          size={10}
          gridColumn="span 2"
          {...register(10)}
        />
        <SLabel gridColumn={5}>標準仕入先</SLabel>
        <SNumberField
          name="shireCd"
          code
          size={6}
          dialog={<B000170 />}
          handleSubmit={(data: any) => {
            methods.setValue("shireCd", data.shireCd);
            methods.setValue("shireNmr", data.shireNmr);
          }}
          onBlur={() => B000170ShireNmr(methods, navigate, setMsg)}
          {...register(11)}
        />
        <STextField name="shireNmr" disabled gridColumn="span 2" />

        <SLabel required gridColumn={1}>
          取引開始年月日
        </SLabel>
        <SDateField
          name="torihikikaishiYmd"
          label="取引開始年月日"
          required
          gridColumn="span 2"
          {...register(12)}
        />
        <SLabel required gridColumn={5}>
          取引終了年月日
        </SLabel>
        <SDateField
          name="torihikishuryoYmd"
          label="取引終了年月日"
          required
          gridColumn="span 2"
          {...register(13)}
        />

        <SLabel gridColumn={1}>ITFコード</SLabel>
        <STextField
          name="itfCd"
          size={16}
          gridColumn="span 2"
          {...register(14)}
        />
      </SFrame>

      <SFrame gridTemplateColumns="8rem 12rem 8rem 5rem 7rem 5rem 8rem 6rem 11rem">
        <SLabel gridColumn="span 2">販売側 設定値</SLabel>

        <SLabel required gridColumn={1}>
          課税区分
        </SLabel>
        <SCodeSelect
          name="kazeiKbn"
          label="課税区分"
          options={KazeiKbn}
          required
          {...register(15)}
        />
        <SLabel required gridColumn={1}>
          単価区分
        </SLabel>
        <SCodeSelect
          name="tankaKbn"
          label="単価区分"
          options={TankaKbn}
          required
          onChange={() => changeTankaKbn()}
          {...register(16)}
        />
        <SLabel gridColumn={3}>WH単価</SLabel>
        <SNumberField
          name="whtankaCd"
          label="WH単価コード"
          code
          size={4}
          disabled={!isTankaKbnWhtanka}
          dialog={<B000111 meishoKbn={meishoKbn.whTanka} />}
          handleSubmit={(data: any) => {
            methods.setValue("whtankaCd", data.meishoCd);
            methods.setValue("whtankaNm", data.meishoNm1);
          }}
          onBlur={() => B000111WhtankaNm(methods, navigate, setMsg)}
          {...register(17)}
        />
        <STextField name="whtankaNm" disabled size={10} gridColumn="span 2" />
        <SLabel gridColumn={7}>WH原単価</SLabel>
        <SNumberField
          name="whgentankaCd"
          code
          size={4}
          disabled={!isTankaKbnWhtanka}
          dialog={<B000111 meishoKbn={meishoKbn.whGentanka} />}
          handleSubmit={(data: any) => {
            methods.setValue("whgentankaCd", data.meishoCd);
            methods.setValue("whgentankaNm", data.meishoNm1);
          }}
          onBlur={() => B000111WhgentankaNm(methods, navigate, setMsg)}
          {...register(18)}
        />
        <STextField name="whgentankaNm" disabled size={10} />

        <SLabel required gridColumn={1}>
          セット商品
        </SLabel>
        <SCodeSelect
          name="setshohinKbn"
          label="セット商品"
          options={SetshohinKbn}
          required
          onChange={() => changeSetshohin()}
          {...register(19)}
        />
        <SLabel required gridColumn={3}>
          商品種別
        </SLabel>
        <SCodeSelect
          name="shohinshubetsuKbn"
          label="商品種別"
          options={ShohinshubetsuKbn}
          required
          disabled={isSetshohin}
          onChange={() => changeShohinshubetsu()}
          gridColumn="span 2"
          {...register(20)}
        />

        <SLabel required gridColumn={1}>
          売切区分
        </SLabel>
        <SCodeSelect
          name="urikiriKbn"
          label="売切区分"
          options={UrikiriKbn}
          required
          {...register(21)}
        />
        <SLabel gridColumn={3}>材料品コード</SLabel>
        <SNumberField
          name="zairyoshohinCd"
          code
          size={10}
          disabled={!isMikomiOrJuchuSeisanhin}
          gridColumn="span 2"
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("zairyoshohinCd", data.shohinCd);
            methods.setValue("zairyoshohinNm", data.shohinNm);
          }}
          onBlur={() => B000200ZairyoshohinNm(methods, navigate, setMsg)}
          {...register(22)}
        />
        <STextField
          name="zairyoshohinNm"
          disabled
          size={24}
          gridColumn="span 3"
        />
      </SFrame>

      <SFrame gridTemplateColumns="8rem 5rem 2rem 5rem 8rem 5rem 2rem 5rem 8rem 5rem 7rem">
        <SLabel gridColumn="span 4">製造側 設定値</SLabel>
        <SLabel gridColumn={1}>足し寸</SLabel>
        <SNumberField
          name="tashisun"
          size={4}
          disabled={!isZairyohin}
          {...register(23)}
        />
        <SLabel gridColumn={5}>ロス</SLabel>
        <SNumberField
          name="loss2"
          size={4}
          disabled={!isZairyohin}
          {...register(24)}
        />
        <SLabel gridColumn={9}>寸法</SLabel>
        <SNumberField
          name="sunpo"
          size={4}
          disabled={!isZairyohin}
          {...register(25)}
        />

        <SLabel gridColumn={1}>WH（外）</SLabel>
        <SNumberField
          name="sotosunW"
          size={4}
          disabled={isZairyohin}
          {...register(26)}
        />
        <SText>×</SText>
        <SNumberField
          name="sotosunH"
          size={4}
          disabled={isZairyohin}
          {...register(27)}
        />

        <SLabel gridColumn={1}>WH（内）</SLabel>
        <SNumberField
          name="uchisunW"
          size={4}
          disabled={isZairyohin}
          {...register(28)}
        />
        <SText>×</SText>
        <SNumberField
          name="uchisunH"
          size={4}
          disabled={isZairyohin}
          {...register(29)}
        />

        <SLabel gridColumn={1}>加工種別</SLabel>
        <SNumberField
          name="kakoshubetsuCd"
          code
          size={3}
          disabled={!isMikomiOrJuchuSeisanhin}
          dialog={<B000111 meishoKbn={meishoKbn.kakoshubetsu} />}
          handleSubmit={(data: any) => {
            methods.setValue("kakoshubetsuCd", data.meishoCd);
            methods.setValue("kakoshubetsuNm", data.meishoNm1);
          }}
          onBlur={() => B000111KakoshubetsuNm(methods, navigate, setMsg)}
          {...register(30)}
        />
        <STextField
          name="kakoshubetsuNm"
          disabled
          size={20}
          gridColumn="span 3"
        />

        <SLabel gridColumn={1}>仕様１</SLabel>
        <STextField
          name="shiyo1"
          size={10}
          disabled={!isMikomiOrJuchuSeisanhin}
          gridColumn="span 3"
          {...register(31)}
        />
        <SLabel gridColumn={5}>仕様２</SLabel>
        <STextField
          name="shiyo2"
          size={10}
          disabled={!isMikomiOrJuchuSeisanhin}
          gridColumn="span 3"
          {...register(32)}
        />
        <SLabel gridColumn={9}>仕様３</SLabel>
        <STextField
          name="shiyo3"
          size={10}
          disabled={!isMikomiOrJuchuSeisanhin}
          gridColumn="span 2"
          {...register(33)}
        />

        <SLabel required gridColumn={1}>
          在庫管理
        </SLabel>
        <SCodeSelect
          name="zaikokanriKbn"
          options={ZaikokanriKbn}
          required
          onChange={() => chengeZaikokanri()}
          gridColumn="span 3"
          {...register(34)}
        />

        <SLabel required gridColumn={1}>
          在庫引当
        </SLabel>
        <SCodeSelect
          name="zaikohikiateKbn"
          label="在庫引当"
          options={ZaikohikiateKbn}
          required
          disabled={isKanriShinai}
          onChange={() => chengeZaikohikiate()}
          gridColumn="span 3"
          {...register(35)}
        />

        <SLabel required gridColumn={1}>
          マイナス在庫
        </SLabel>
        <SCodeSelect
          name="minuszaikocheckKbn"
          label="マイナス在庫"
          options={MinuszaikocheckKbn}
          required
          disabled={!isHikiateShinai}
          gridColumn="span 3"
          {...register(36)}
        />

        <SLabel gridColumn={1}>削除予定区分</SLabel>
        <SCodeSelect
          name="sakujoyoteiKbn"
          options={SakujoyoteiKbn}
          gridColumn="span 3"
          {...register(37)}
        />
      </SFrame>

      <SFrame gridTemplateColumns="8rem 5rem 15rem 8rem 5rem 15rem ">
        <SLabel gridColumn="span 3">商品分類</SLabel>

        <SLabel gridColumn={1}>商品分類１</SLabel>
        <SNumberField
          name="shobunCd1"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.shohinbun1} />}
          handleSubmit={(data: any) => {
            methods.setValue("shobunCd1", data.meishoCd);
            methods.setValue("shobunNm1", data.meishoNm1);
          }}
          onBlur={() => B000111ShobumNm1(methods, navigate, setMsg)}
          {...register(38)}
        />
        <STextField name="shobunNm1" label="商品分類名１" disabled size={20} />
        <SLabel gridColumn={4}>商品大分類</SLabel>
        <SNumberField
          name="shodaibun"
          code
          size={3}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            methods.setValue("shodaibun", data.shodaibun ?? "");
            methods.setValue("shodaibunNm", data.shohindaibunruiNm ?? "");
            methods.setValue("shochubun", data.shochubun ?? "");
            methods.setValue("shochubunNm", data.shohinchubunruiNm ?? "");
            methods.setValue("shoshobun", data.shoshobun ?? "");
            methods.setValue("shoshobunNm", data.shohinshobunruiNm ?? "");
          }}
          onBlur={() => B000202ShodaibunruiNm(methods, navigate, setMsg)}
          {...register(43)}
        />
        <STextField name="shodaibunNm" disabled size={20} />

        <SLabel gridColumn={1}>商品分類２</SLabel>
        <SNumberField
          name="shobunCd2"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.shohinbun2} />}
          handleSubmit={(data: any) => {
            methods.setValue("shobunCd2", data.meishoCd);
            methods.setValue("shobunNm2", data.meishoNm1);
          }}
          onBlur={() => B000111ShobumNm2(methods, navigate, setMsg)}
          {...register(39)}
        />
        <STextField name="shobunNm2" label="商品分類名２" disabled size={20} />
        <SLabel gridColumn={4}>商品中分類</SLabel>
        <SNumberField
          name="shochubun"
          code
          size={3}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            methods.setValue("shodaibun", data.shodaibun ?? "");
            methods.setValue("shodaibunNm", data.shohindaibunruiNm ?? "");
            methods.setValue("shochubun", data.shochubun ?? "");
            methods.setValue("shochubunNm", data.shohinchubunruiNm ?? "");
            methods.setValue("shoshobun", data.shoshobun ?? "");
            methods.setValue("shoshobunNm", data.shohinshobunruiNm ?? "");
          }}
          onBlur={() => B000202ShochubunruiNm(methods, navigate, setMsg)}
          {...register(44)}
        />
        <STextField name="shochubunNm" disabled size={20} />

        <SLabel gridColumn={1}>商品分類３</SLabel>
        <SNumberField
          name="shobunCd3"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.shohinbun3} />}
          handleSubmit={(data: any) => {
            methods.setValue("shobunCd3", data.meishoCd);
            methods.setValue("shobunNm3", data.meishoNm1);
          }}
          onBlur={() => B000111ShobumNm3(methods, navigate, setMsg)}
          {...register(40)}
        />
        <STextField name="shobunNm3" disabled size={20} />
        <SLabel gridColumn={4}>商品小分類</SLabel>
        <SNumberField
          name="shoshobun"
          code
          size={3}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            methods.setValue("shodaibun", data.shodaibun ?? "");
            methods.setValue("shodaibunNm", data.shohindaibunruiNm ?? "");
            methods.setValue("shochubun", data.shochubun ?? "");
            methods.setValue("shochubunNm", data.shohinchubunruiNm ?? "");
            methods.setValue("shoshobun", data.shoshobun ?? "");
            methods.setValue("shoshobunNm", data.shohinshobunruiNm ?? "");
          }}
          onBlur={() => B000202ShoshobunruiNm(methods, navigate, setMsg)}
          {...register(45)}
        />
        <STextField name="shoshobunNm" disabled size={20} />

        <SLabel gridColumn={1}>商品分類４</SLabel>
        <SNumberField
          name="shobunCd4"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.shohinbun4} />}
          handleSubmit={(data: any) => {
            methods.setValue("shobunCd4", data.meishoCd);
            methods.setValue("shobunNm4", data.meishoNm1);
          }}
          onBlur={() => B000111ShobumNm4(methods, navigate, setMsg)}
          {...register(41)}
        />
        <STextField name="shobunNm4" label="商品分類名４" disabled size={20} />

        <SLabel gridColumn={1}>商品分類５</SLabel>
        <SNumberField
          name="shobunCd5"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.shohinbun5} />}
          handleSubmit={(data: any) => {
            methods.setValue("shobunCd5", data.meishoCd);
            methods.setValue("shobunNm5", data.meishoNm1);
          }}
          onBlur={() => B000111ShobumNm5(methods, navigate, setMsg)}
          {...register(42)}
        />
        <STextField name="shobunNm5" label="商品分類名５" disabled size={20} />
      </SFrame>

      <SFrame gridTemplateColumns="8rem 5rem 15rem 9rem 5rem 15rem ">
        <SLabel gridColumn="span 4">帳票分類</SLabel>

        <SLabel gridColumn={1}>帳票分類コード１</SLabel>
        <SNumberField
          name="chohyoBunruiCd1"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd1} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd1", data.meishoCd);
            methods.setValue("chohyoBunruiNm1", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm1(methods, navigate, setMsg)}
          {...register(46)}
        />
        <STextField name="chohyoBunruiNm1" disabled size={20} />
        <SLabel gridColumn={4}>帳票分類コード９</SLabel>
        <SNumberField
          name="chohyoBunruiCd9"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd9} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd9", data.meishoCd);
            methods.setValue("chohyoBunruiNm9", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm9(methods, navigate, setMsg)}
          {...register(54)}
        />
        <STextField name="chohyoBunruiNm9" disabled size={20} />

        <SLabel gridColumn={1}>帳票分類コード２</SLabel>
        <SNumberField
          name="chohyoBunruiCd2"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd2} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd2", data.meishoCd);
            methods.setValue("chohyoBunruiNm2", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm2(methods, navigate, setMsg)}
          {...register(47)}
        />
        <STextField name="chohyoBunruiNm2" disabled size={20} />
        <SLabel gridColumn={4}>帳票分類コード１０</SLabel>
        <SNumberField
          name="chohyoBunruiCd10"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd10} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd10", data.meishoCd);
            methods.setValue("chohyoBunruiNm10", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm10(methods, navigate, setMsg)}
          {...register(55)}
        />
        <STextField name="chohyoBunruiNm10" disabled size={20} />

        <SLabel gridColumn={1}>帳票分類コード３</SLabel>
        <SNumberField
          name="chohyoBunruiCd3"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd3} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd3", data.meishoCd);
            methods.setValue("chohyoBunruiNm3", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm3(methods, navigate, setMsg)}
          {...register(48)}
        />
        <STextField name="chohyoBunruiNm3" disabled size={20} />
        <SLabel gridColumn={4}>帳票分類コード１１</SLabel>
        <SNumberField
          name="chohyoBunruiCd11"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd11} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd11", data.meishoCd);
            methods.setValue("chohyoBunruiNm11", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm11(methods, navigate, setMsg)}
          {...register(56)}
        />
        <STextField name="chohyoBunruiNm11" disabled size={20} />

        <SLabel gridColumn={1}>帳票分類コード４</SLabel>
        <SNumberField
          name="chohyoBunruiCd4"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd4} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd4", data.meishoCd);
            methods.setValue("chohyoBunruiNm4", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm4(methods, navigate, setMsg)}
          {...register(49)}
        />
        <STextField name="chohyoBunruiNm4" disabled size={20} />
        <SLabel gridColumn={4}>帳票分類コード１２</SLabel>
        <SNumberField
          name="chohyoBunruiCd12"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd12} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd12", data.meishoCd);
            methods.setValue("chohyoBunruiNm12", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm12(methods, navigate, setMsg)}
          {...register(57)}
        />
        <STextField name="chohyoBunruiNm12" disabled size={20} />

        <SLabel gridColumn={1}>帳票分類コード５</SLabel>
        <SNumberField
          name="chohyoBunruiCd5"
          label="帳票分類コード５"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd5} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd5", data.meishoCd);
            methods.setValue("chohyoBunruiNm5", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm5(methods, navigate, setMsg)}
          {...register(50)}
        />
        <STextField name="chohyoBunruiNm5" disabled size={20} />
        <SLabel gridColumn={4}>帳票分類コード１３</SLabel>
        <SNumberField
          name="chohyoBunruiCd13"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd13} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd13", data.meishoCd);
            methods.setValue("chohyoBunruiNm13", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm13(methods, navigate, setMsg)}
          {...register(58)}
        />
        <STextField name="chohyoBunruiNm13" disabled size={20} />

        <SLabel gridColumn={1}>帳票分類コード６</SLabel>
        <SNumberField
          name="chohyoBunruiCd6"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd6} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd6", data.meishoCd);
            methods.setValue("chohyoBunruiNm6", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm6(methods, navigate, setMsg)}
          {...register(51)}
        />
        <STextField name="chohyoBunruiNm6" disabled size={20} />
        <SLabel gridColumn={4}>帳票分類コード１４</SLabel>
        <SNumberField
          name="chohyoBunruiCd14"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd14} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd14", data.meishoCd);
            methods.setValue("chohyoBunruiNm14", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm14(methods, navigate, setMsg)}
          {...register(59)}
        />
        <STextField name="chohyoBunruiNm14" disabled size={20} />

        <SLabel gridColumn={1}>帳票分類コード７</SLabel>
        <SNumberField
          name="chohyoBunruiCd7"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd7} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd7", data.meishoCd);
            methods.setValue("chohyoBunruiNm7", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm7(methods, navigate, setMsg)}
          {...register(52)}
        />
        <STextField
          name="chohyoBunruiNm7"
          label="帳票分類名７"
          disabled
          size={20}
        />
        <SLabel gridColumn={4}>帳票分類コード１５</SLabel>
        <SNumberField
          name="chohyoBunruiCd15"
          label="帳票分類コード１５"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd15} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd15", data.meishoCd);
            methods.setValue("chohyoBunruiNm15", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm15(methods, navigate, setMsg)}
          {...register(60)}
        />
        <STextField
          name="chohyoBunruiNm15"
          label="帳票分類名１５"
          disabled
          size={20}
        />

        <SLabel gridColumn={1}>帳票分類コード８</SLabel>
        <SNumberField
          name="chohyoBunruiCd8"
          label="帳票分類コード８"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.chobobunruiCd8} />}
          handleSubmit={(data: any) => {
            methods.setValue("chohyoBunruiCd8", data.meishoCd);
            methods.setValue("chohyoBunruiNm8", data.meishoNm1);
          }}
          onBlur={() => B000111ChohyoBunruiNm8(methods, navigate, setMsg)}
          {...register(53)}
        />
        <STextField
          name="chohyoBunruiNm8"
          label="帳票分類名８"
          disabled
          size={20}
        />
      </SFrame>
      <SFrame>
        <SNormalButton
          label={labels.buttons.update}
          align="right"
          dialog={
            <SConfirmDialog
              title="マスタ更新"
              msg="更新します。よろしいですか？"
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickUpdateButton}
          {...register(61)}
        />
      </SFrame>
    </FormProvider>
  );
};
